var isNumeric = function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
};
export default isNumeric;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/isNumeric.js
// module id = 1099
// module chunks = 0